<template>
  <div>
    <div>
      <el-dialog
        title="工程造价行业信息登记要求"
        :visible.sync="dialogVisible"
        width="710px"
        :close-on-click-modal="false"
      >
        <!--        :before-close="handleClose"-->
        <div class="textCont">
          <p
            style="margin-top: 12px; white-space: pre-wrap"
            v-html="content"
          ></p>
        </div>
        <span slot="footer" class="dialog-footer">
          <div class="b" @click="is_read" :class="status ? 'blue' : 'gray'">
            确 定{{ countDown ? "(" + countDown + "秒后可点击关闭" + ")" : "" }}
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getClause, atClause } from "@/api/index.js";

export default {
  data() {
    return {
      dialogVisible: true,
      content: "",
      countDown: 15, // 倒计时
      timer: null, // 定时器
      status: false, //状态  true倒计时结束
      read: false, //是否已读
    };
  },
  watch: {
    countDown(val) {
      if (val === 0) {
        clearInterval(this.timer);
        this.status = true;
        this.read = true; //已读
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  created() {
    //获取登录须知
    if (this.userinfo.company_info.is_look_agre === 0) {
      this.init();
    }
    //倒计时
    this.timer = setInterval(() => {
      this.countDown--;
    }, 1000);
  },
  methods: {
    async init() {
      try {
        const res = await getClause();
        // console.log(res, "阅读须知----");
        this.content = res.content;
      } catch (error) {
        this.$message.error(error.msg);
      }
    },
    async is_read() {
      if (this.read) {
        //通知后端已读了
        await atClause();
        //改变前端
        this.$store.commit("changeReadStatus", 1);
        this.dialogVisible = false;
        this.$emit("update:changeReadStatus", 1);
        // localStorage.setItem("skk_is_read_arg", 1);
        this.$emit("readedBack", 1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.banner {
  width: 1200px;
  height: 60px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 2px;
}

/deep/ .el-dialog__header {
  display: flex;
  justify-content: flex-start;
}

/deep/ .el-dialog__title {
  font-size: 16px;
  color: #333333;
}

/deep/ .el-dialog__footer {
  display: flex;
  justify-content: center;
}

/deep/ .el-button--primary {
  height: 38px;
  border-radius: 2px;
  background: #4379f6;
  box-shadow: 0px 3px 6px 0px rgba(67, 121, 246, 0.2);
}

.b {
  min-width: 100px;
  height: 38px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 0 10px;
  color: #ffffff;
  cursor: pointer;
}

.gray {
  background: #cccccc;
  cursor: not-allowed;
  border: #cccccc;
}

.blue {
  background: #4379f6;
  box-shadow: 0px 3px 6px 0px rgba(67, 121, 246, 0.2);
}

/deep/ .el-dialog__body {
  padding: 5px 20px;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

///deep/ .el-button--primary:hover {
//  color: unset;
//  border-color: unset;
//  background-color: unset;
//}
//
///deep/ .el-button:hover {
//  color: unset;
//  border-color: unset;
//  background-color: unset;
//}

.textCont {
  width: 100%;
  height: 384px;
  background: #ffffff;
  border: 1px solid #dddddd;
  overflow-y: auto;
  padding: 27px 23px;
  box-sizing: border-box;

  p {
    font-size: 14px;
    color: #333333;
    line-height: 24px;
  }
}

//自定义滚动条
//
::-webkit-scrollbar {
  width: 8px;
  height: 16px;
  background-color: #f5f5f5;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgb(193, 193, 193);
}
</style>
